import { render, staticRenderFns } from "./MemberDetailHeader.vue?vue&type=template&id=1039aec2"
import script from "./MemberDetailHeader.vue?vue&type=script&lang=js"
export * from "./MemberDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./MemberDetailHeader.vue?vue&type=style&index=0&id=1039aec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports